import { render, staticRenderFns } from "./OurProjects.vue?vue&type=template&id=da01a412&scoped=true&"
import script from "./OurProjects.vue?vue&type=script&lang=js&"
export * from "./OurProjects.vue?vue&type=script&lang=js&"
import style0 from "./OurProjects.vue?vue&type=style&index=0&id=da01a412&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da01a412",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
